import { api } from './http';

export interface ISenderTokenResponse {
	token: string;
	expiresIn: number;
}

export async function fetchSenderToken() {
	const { data } = await api.post<ISenderTokenResponse>('/sender-token', {}, { suppressToast: true });
	return data;
}
